import { useKeycloak } from '@react-keycloak/web';
import React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { Modules, Roles } from '../../types';
import { NoAccessComponent } from './NoAccessComponent';
import { useUserAccessControl } from './private-routes.service';

export interface AccessControl {
  accessModule?: Modules | Modules[];
  accessRoles?: Roles[];
  allRolesRequired?: boolean;
}
export interface PrivateRouteProps extends RouteProps, AccessControl {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

export function PrivateRoute({
  component: Component,
  accessModule,
  accessRoles,
  allRolesRequired,
  ...rest
}: PrivateRouteProps) {
  const { keycloak } = useKeycloak();
  const { userHasAccess } = useUserAccessControl();

  return (
    <Route
      {...rest}
      render={(props) =>
        keycloak?.authenticated ? (
          userHasAccess(accessModule, accessRoles, allRolesRequired) ? (
            <Component {...props} />
          ) : (
            <NoAccessComponent />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.history.createHref(props.location) },
            }}
          />
        )
      }
    />
  );
}
